import { useEffect, useState } from "react";
import "./CareerProgram.css";
import { Card, message, Input, Spin, Empty, Tag, Pagination } from "antd";
import { useNavigate } from "react-router-dom";
import axios from "axios";
import { BaseUrl, AssesmentUrl } from "../Constants/Constants";
import { useStateValue } from "../../Reducer/reducer";
import { useLocation } from "react-router-dom";
import WorkIcon from "@mui/icons-material/Work";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import SearchIcon from "@mui/icons-material/Search";
import AutoAwesomeIcon from "@mui/icons-material/AutoAwesome";
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";
import { useParams } from "react-router-dom";

const CareerProgram = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const selectedGroupName = location.state?.groupName;
  const selectedCourseIds = location.state?.courseIds || [];

  const [{ UserID, companyId }, dispatch] = useStateValue();
  const { groupId } = useParams();


  const [courses, setCourses] = useState([]);
  const [filteredCourses, setFilteredCourses] = useState([]);
  const [loading, setLoading] = useState(true);
  const [searchValue, setSearchValue] = useState("");
  const [assessmentStatusMap, setAssessmentStatusMap] = useState({});
  const [assessmentLoaded, setAssessmentLoaded] = useState(false);

  // Pagination state
  const [currentPage, setCurrentPage] = useState(1);
  const [pageSize] = useState(10);

  console.log(companyId, "companyId");

  //for showing modules
  useEffect(() => {
    if (!assessmentLoaded) return; // ⛔ wait for assessment

    if (UserID != undefined || UserID != "") {
      setLoading(true);

      const body = { userId: UserID };

      axios
        .post(`${BaseUrl}career-course-mapping/getAllCourses`, body, {
          withCredentials: true,
        })
        .then((res) => {
          if (res.data.statuscode === 200) {
            let mapped = res.data.data.map((course) => ({
              course_id: course.id,
              course_title: course.title,
              course_description: course.description,
              group_name: course.group_name,
              duration: course.duration_minutes,
              is_learning: course.is_learning === true,

              // ✅ NOW THIS WORKS CORRECTLY
              is_assessment_completed: assessmentStatusMap[course.id] === true,

              imageUrl:
                course.course_image_url && course.course_image_url !== ""
                  ? course.course_image_url
                  : "/icons/CourseIcons.png",

              isLocked: false,
            }));

            let unlockNext = true;
            mapped = mapped.map((c) => {
              if (c.is_learning) return { ...c, isLocked: false };
              if (unlockNext) {
                unlockNext = false;
                return { ...c, isLocked: false };
              }
              return { ...c, isLocked: true };
            });

            let finalCourses = mapped;

            if (selectedGroupName) {
              finalCourses = mapped.filter(
                (course) => course.group_name === selectedGroupName
              );
            }

            setCourses(finalCourses);
            setFilteredCourses(finalCourses);
            setLoading(false);
          }
        })
        .catch(() => {
          setLoading(false);
          message.error("Please login again to continue!");
          navigate("/login");
        });
    }
  }, [assessmentLoaded, assessmentStatusMap]);

  //for showing the status to completed course after taking assesment
  useEffect(() => {
    if (!UserID || selectedCourseIds.length === 0) return;

    const body = {
      user_id: UserID,
      course_ids: selectedCourseIds,
    };

    axios
      .post(`${AssesmentUrl}career_dev_assessment_completion_status`, body)
      .then((res) => {
        if (res.data?.status === 200) {
          const map = {};

          res.data.courses.forEach((c) => {
            map[c.course_id] = c.assessment_completion_status;
          });

          setAssessmentStatusMap(map);
          setAssessmentLoaded(true); // ✅ IMPORTANT
        }
      })
      .catch(() => {
        setAssessmentLoaded(true); // allow UI even if API fails
      });
  }, [UserID, selectedCourseIds]);

  const handleCard = (e) => {
    navigate(`/career-program/group/${groupId}/course/${e.course_id}`
);
  };

  const handleSearch = (value) => {
    setSearchValue(value);
    setCurrentPage(1); // Reset to first page on search

    if (value.trim() === "") {
      setFilteredCourses(courses);
    } else {
      const filtered = courses.filter(
        (item) =>
          item.course_title.toLowerCase().includes(value.toLowerCase()) ||
          item.course_description?.toLowerCase().includes(value.toLowerCase())
      );
      setFilteredCourses(filtered);
    }
  };

  const handlePageChange = (page) => {
    setCurrentPage(page);
    // Scroll to top when page changes
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  // Calculate paginated courses
  const startIndex = (currentPage - 1) * pageSize;
  const endIndex = startIndex + pageSize;
  const paginatedCourses = filteredCourses.slice(startIndex, endIndex);

  return (
    <div className="Courses-main">
      {/* Breadcrumb */}
      <div className="coursesBreadcrumb">
        <span
          className="breadcrumbLink"
          onClick={() => navigate("/career-program")}
        >
          Career Program
        </span>
      </div>

      {/* Header Section */}
      <div className="coursesHeader">
        <div className="coursesHeaderContent">
          <div className="coursesHeaderIconWrapper">
            <WorkIcon className="coursesHeaderIcon" />
          </div>
          <div>
            <h1 className="coursesMainTitle">Career Program</h1>
            <p className="coursesSubtitle">Explore and enhance your Career</p>
          </div>
        </div>
        <div className="coursesSearchWrapper">
          <Input
            placeholder="Search Modules by title or description..."
            onChange={(e) => handleSearch(e.target.value)}
            value={searchValue}
            className="coursesSearchInput"
            allowClear
            prefix={<SearchIcon className="searchIconPrefix" />}
            size="large"
          />
        </div>
      </div>

      {/* Content Section */}
      {loading ? (
        <div className="coursesLoader">
          <Spin size="large" />
        </div>
      ) : (
        <div className="coursesContent">
          {filteredCourses.length === 0 && courses.length > 0 ? (
            <div className="coursesEmptyState">
              <Empty
                description={`No courses found matching "${searchValue}"`}
                image={Empty.PRESENTED_IMAGE_SIMPLE}
              />
            </div>
          ) : (
            <>
              {courses.length !== 0 && (
                <>
                  <div className="coursesGrid">
                    {paginatedCourses.map((item, index) => (
                      <Card
                        key={item.course_id}
                        onClick={() => !item.isLocked && handleCard(item)}
                        hoverable
                        className={`courseCard ${
                          item.isLocked ? "disabledCard" : ""
                        }`}
                        cover={
                          <div className="courseCardCover">
                            <div className="courseCardOverlay">
                              <PlayCircleOutlineIcon className="playIcon" />
                            </div>
                            <img
                              alt="Course Image"
                              src={item.imageUrl}
                              className="courseCardImage"
                            />
                          </div>
                        }
                      >
                        <div className="courseCardContent">
                          <div className="courseCardHeader">
                            <MenuBookIcon className="courseCardIcon" />
                            <h3 className="courseCardTitle">
                              {item.course_title || "Unnamed Course"}
                            </h3>
                          </div>

                          {item.is_assessment_completed ? (
                            <Tag color="green" className="courseCompletedTag">
                              Module Completed
                            </Tag>
                          ) : item.is_learning ? (
                            <Tag color="blue" className="courseCompletedTag">
                              Learning Completed
                            </Tag>
                          ) : null}

                          <div className="courseCardFooter">
                            <span className="courseCardAction">View Parts</span>
                            <AutoAwesomeIcon className="courseCardArrow" />
                          </div>
                        </div>
                      </Card>
                    ))}
                  </div>

                  {/* Pagination */}
                  {filteredCourses.length > pageSize && (
                    <div className="coursesPagination">
                      <Pagination
                        current={currentPage}
                        total={filteredCourses.length}
                        pageSize={pageSize}
                        onChange={handlePageChange}
                        showSizeChanger={false}
                        showTotal={(total, range) =>
                          `${range[0]}-${range[1]} of ${total} courses`
                        }
                      />
                    </div>
                  )}
                </>
              )}

              {courses.length === 0 && (
                <div className="coursesEmptyState">
                  <Empty
                    description="No courses available at the moment"
                    image={Empty.PRESENTED_IMAGE_SIMPLE}
                  />
                </div>
              )}
            </>
          )}
        </div>
      )}
    </div>
  );
};

export default CareerProgram;
